import axios from "axios";

export const deleteComTypeById = async (id) => {
  try {
    const response = await axios.delete(`http://localhost:8080/webnet-hms/api/company-type/${id}`);
    window.alert("Company Type deleted successfully!");
    return response.data;
  } catch (error) {
    console.error("Error deleting Company Type:", error);
    window.alert("Failed to delete Company Type.");
  }
};
